<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="" src="OEBPS/images/3-1.jpg"/></p>
<p class="pagebreak"> <br/></p>
<div class="titlepage">
<h1 class="chapter1">Knitted Toy Tales</h1>
<p class="center">Irresistible characters for all ages</p>
<br/><br/>
<p class="center">LAURA LONG</p>
<br/><br/><br/><br/><br/>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?2263d62a